import { render, staticRenderFns } from "./DepartUserList.vue?vue&type=template&id=234c79e0&scoped=true"
import script from "./DepartUserList.vue?vue&type=script&lang=js"
export * from "./DepartUserList.vue?vue&type=script&lang=js"
import style0 from "./DepartUserList.vue?vue&type=style&index=0&id=234c79e0&prod&lang=scss&scoped=true"
import style1 from "./DepartUserList.vue?vue&type=style&index=1&id=234c79e0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "234c79e0",
  null
  
)

export default component.exports